function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 3H4C2.9 3 2 3.9 2 5.01V19.9C2 20.32 2.25 20.71 2.63 20.89C2.78 20.96 2.94 21 3.1 21C3.35 21 3.59 20.92 3.79 20.76L7.1 18.09H20C21.1 18.09 22 17.19 22 16.08V5.01C22 3.9 21.1 3 20 3ZM20 16.09H6.4L4 18.02V5H20V16.09ZM8.74 10.83C7.85 9.95 7.85 8.53 8.74 7.65C9.63 6.77 11.08 6.77 11.97 7.65C11.99 7.67 12.01 7.67 12.03 7.65C12.92 6.77 14.37 6.77 15.26 7.65C16.15 8.53 16.15 9.95 15.26 10.83L12.04 13.99C12.04 13.99 12.02 13.99 12.01 13.99C12 13.99 11.99 13.99 11.98 13.99C11.97 13.99 11.96 13.99 11.95 13.99L8.73 10.83H8.74Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=CommentHeart.js.map